import {
  Card,
  CardHeader,
  Typography,
  Button,
  useMediaQuery,
} from "@mui/material";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTheme } from "@emotion/react";
import { IoIosAddCircleOutline } from "react-icons/io";
import { setDialog } from "../../../../../app/slices/capitalAmountSlice";
import CapitalAmountForm from "../../form";
import { GiMoneyStack } from "react-icons/gi";
import Permission from "../../../../../components/userPermission/userPermission";

const CapitalAmountHeader = () => {
  const _CapitalAmount = useSelector((state) => state.capitalAmount);
  const dispatch = useDispatch();

  const theme = useTheme();
  const smallScreen = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Card>
      <CardHeader
        sx={{
          flexWrap: "wrap",
          rowGap: 1.5,
          "& .MuiCardHeader-action": {
            m: 0,
            ...(smallScreen && { width: "100%" }),
          },
        }}
        title={
          <Typography variant="h4" component="div">
            رأس المال
          </Typography>
        }
        avatar={<GiMoneyStack size={20} />}
        action={
          <Permission permission="capital_amount_edit">
            <Button
              fullWidth={smallScreen}
              variant="contained"
              color="primary"
              size="medium"
              startIcon={<IoIosAddCircleOutline />}
              onClick={() => dispatch(setDialog())}
            >
              إضافة رأس مال جديد
            </Button>
          </Permission>
        }
      />
      {_CapitalAmount.capitalAmount.dialog ? <CapitalAmountForm /> : null}
    </Card>
  );
};

export default CapitalAmountHeader;
